import { Controller } from "stimulus"

// TODO: Make this component accessible (respond to tabbing)
export default class extends Controller {
  static targets = [ "output", "button" ]

  initialize() {
    if (this.outputTarget.value) {
      this.buttonTargets.forEach(el => {
        el.classList.toggle('is-active', (el.dataset.radioSelectValue == this.outputTarget.value))
      })
    }
  }

  select(event) {
    event.preventDefault();
    this.clearSelection();
    event.currentTarget.classList.add('is-active');
    this.outputTarget.value = event.currentTarget.dataset.radioSelectValue;
    // Answered: drop the required-field flag (shown on the buttons, see donation_flow.scss).
    this.outputTarget.classList.remove('is-danger');
    
    // Update partner_id field if this is a portfolio selection
    if (event.currentTarget.dataset.partnerId) {
      const partnerIdField = document.querySelector('[name="pledge_form[partner_id]"]');
      if (partnerIdField) {
        partnerIdField.value = event.currentTarget.dataset.partnerId;
      }
    }
  }

  clearSelection(event) {
    this.buttonTargets.forEach(el => el.classList.remove('is-active'))
  }
}
